import { FormattedMessage } from "react-intl";

const DeploymentGating = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraServiceManagementPricingPageTeam24.features.deploymentGating.content.body"
                    defaultMessage="Automate or create approval processes for deployments initiated via connected CI/CD tools."
                />
            </p>
        </div>
    );
};

export default DeploymentGating;
